module.exports = __webpack_public_path__ + "img/monitor-manage-card-icon.png";